<mat-form-field class="geo-location-form-field" appearance="outline" floatLabel="always">
  <mat-label>Geo location</mat-label>
  <input
    matInput
    [formControl]="geoLocationSearchControl"
    [matAutocomplete]="geoLocationAutocomplete"
    placeholder="Pick one or more"
    (focus)="openGeoLocationAutocompletePanel()"
  />
  @if (countryCodesControl.value && countryCodesControl.value.length) {
    <span class="country-selection-summary" matPrefix aria-hidden="true">
      <span class="country-selection-count">{{
        countryCodesControl.value ? countryCodesControl.value.length : ''
      }}</span>
      <button type="button" class="country-selection-clear-prefix" (click)="clearCountrySelection()">X</button>
    </span>
  }
  @if (geoLocationSearchControl.value) {
    <button
      class="country-selection-clear-suffix"
      matSuffix
      type="button"
      matIconButton
      (click)="clearGeoLocationSearch($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-icon class="geo-location-toggle-icon" matSuffix>
    {{ geoLocationAutocompleteTrigger?.panelOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}
  </mat-icon>
</mat-form-field>

<mat-autocomplete
  #geoLocationAutocomplete="matAutocomplete"
  class="geo-location-autocomplete-panel"
  [hideSingleSelectionIndicator]="true"
>
  @for (
    continentWithCountries of this.filteredContinentsWithCountries;
    track continentWithCountries.continentWithCountries.name
  ) {
    <div class="country-autocomplete-group">
      <div class="continent-toggle">
        <button
          class="continent-select"
          type="button"
          (click)="onContinentSelected(continentWithCountries.continentWithCountries)"
        >
          <mat-checkbox
            disableRipple
            [checked]="isContinentFullySelected(continentWithCountries.continentWithCountries)"
            [indeterminate]="isContinentIndeterminate(continentWithCountries.continentWithCountries)"
          />
          <span>{{ continentWithCountries.continentWithCountries.label }}</span>
        </button>

        <button
          class="continent-expand"
          type="button"
          (click)="toggleContinentExpansion(continentWithCountries.continentWithCountries.name)"
        >
          <mat-icon>{{
            isContinentExpanded(continentWithCountries.continentWithCountries.name) ? 'expand_less' : 'expand_more'
          }}</mat-icon>
        </button>
      </div>

      @if (shouldShowContinentCountries(continentWithCountries.continentWithCountries.name)) {
        @for (country of continentWithCountries.filteredCountries; track country) {
          <mat-option [value]="geoLocationSearchControl.value" (onSelectionChange)="onCountrySelected($event, country)">
            <div class="country-option-content">
              <mat-checkbox disableRipple [checked]="isCountrySelected(country)" />
              <span>{{ CountryDescriptor[country] }}</span>
            </div>
          </mat-option>
        }
      }
    </div>
  }
</mat-autocomplete>
